module.exports = {
  messages: {
    CN: {
      'labelingManagement.labelingManagement': '商品标签管理',
      'labelingManagement.labelingName': '标签名称',
      'labelingManagement.labelingType': '标签类型',
      'labelingManagement.condition': '条件',
      'labelingManagement.productQuantity': '商品数量',
      'labelingManagement.addedDays': '上架天数',
      'labelingManagement.deliveryChannel': '发货渠道',
      'labelingManagement.productLabeling': '商品标签'
    },
    JP: {
      'labelingManagement.labelingManagement': '商品标签管理',
      'labelingManagement.labelingName': 'タグ名',
      'labelingManagement.labelingType': 'タグタイプ',
      'labelingManagement.condition': '条件',
      'labelingManagement.productQuantity': '商品数量',
      'labelingManagement.addedDays': '販売開始日数',
      'labelingManagement.deliveryChannel': '发货渠道',
      'labelingManagement.productLabeling': '商品タグ'
    }
  }
};